export default __webpack_public_path__ + "static/salade-7e71076601d829fa90645311bb7ee984.jpg";